
<div class="deactivate-auth-container" style="font-family: Montserrat;">
    <mat-icon style="cursor: pointer;" (click)="closePopUp('cancel')">close</mat-icon>
    <div>
        <div class="auth-content" style="font-size: 18px;">
            <p>
                Are you sure you want to deactivate authentication?
            </p>
        </div>
            <p style="font-size: 12px; margin-top: 8px;">
                Any authentication data stored may be lost once you deactivate.
            </p>
    </div>
</div>
<div class="auth-button" style="font-family: Montserrat;">
    <button (click) ="closePopUp('cancel')" style="border-radius: 40px; color: #386AF6; text-align: center; background-color: white;">No</button>
    <button (click)="closePopUp('confirm')" style="border-radius: 80px; background-color: #386AF6; color: white;">Yes</button>
</div>
